import { render, staticRenderFns } from "./ModalComandasMesa.vue?vue&type=template&id=77756c17&scoped=true&"
import script from "./ModalComandasMesa.vue?vue&type=script&lang=js&"
export * from "./ModalComandasMesa.vue?vue&type=script&lang=js&"
import style0 from "./ModalComandasMesa.vue?vue&type=style&index=0&id=77756c17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77756c17",
  null
  
)

export default component.exports